import React from "react";
import "./animation.less";

class Animation extends React.Component {
    //构造函数
    constructor() {
        super();
    }

    componentDidMount() {
        particlesJS("particles-js", {
            particles: {
                number: {
                    value: 30,
                    density: {
                        enable: true,
                        value_area: 800,
                    },
                },
                color: {
                    value: "#CFDAE6",
                },
                opacity: {
                    value: 1,
                    random: false,
                    anim: {
                        enable: false,
                        speed: 1,
                        opacity_min: 0.1,
                        sync: false,
                    },
                },
                size: {
                    value: 3,
                    random: true,
                    anim: {
                        enable: false,
                        speed: 40,
                        size_min: 0.1,
                        sync: false,
                    },
                },
                line_linked: {
                    enable: true,
                    distance: 150,
                    color: "#CFDAE6",
                    opacity: 0.4,
                    width: 1,
                },
                move: {
                    enable: true,
                    speed: 3,
                    direction: "none",
                    random: false,
                    straight: false,
                    out_mode: "out",
                    bounce: false,
                    attract: {
                        enable: false,
                        rotateX: 600,
                        rotateY: 1200,
                    },
                },
            },
        });
    }

    render() {
        return <div id="particles-js"></div>;
    }
}
export default Animation;
